exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-classes-pc .board{cursor:pointer;padding:5px 8px 15px;background:#fff 0 0 no-repeat padding-box;box-shadow:0 1px 2px #00000029;border-radius:10px;display:block}.item-classes-pc .board .board-info{margin-top:16px}.item-classes-pc .board .board-info .title-classes{color:#343a40;font-size:15px;min-height:40px;display:table;width:100%;text-align:center}.item-classes-pc .board .board-info .title-classes span{display:table-cell;vertical-align:middle}@media screen and (max-width:991px){.item-classes-pc{width:25%}}@media screen and (max-width:640px){.item-classes-pc{width:33.33%}}@media screen and (max-width:480px){.item-classes-pc{width:50%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-609f5a6c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Lesson_Planning/itemClasses.vue
// module id = 1104
// module chunks = 0